export const SORTING = {
    SORTING_DESC: 'desc',
    SORTING_ASC: 'asc',
}
